import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface TimesheetsDateRange {
  fromDate: string;
  toDate: string;
}

@Injectable({ providedIn: 'root' })
export class TimesheetsFilterStateService {
  private readonly rangeSubject = new BehaviorSubject<TimesheetsDateRange>(this.currentYearToDateRange());
  readonly range$ = this.rangeSubject.asObservable();

  private readonly searchSubject = new Subject<TimesheetsDateRange>();
  readonly search$ = this.searchSubject.asObservable();

  get range(): TimesheetsDateRange {
    return this.rangeSubject.value;
  }

  search(fromDate: string, toDate: string): void {
    if (!this.isValidRange(fromDate, toDate)) return;
    const range = { fromDate, toDate };
    this.rangeSubject.next(range);
    this.searchSubject.next(range);
  }

  resetToCurrentYear(): TimesheetsDateRange {
    const range = this.currentYearToDateRange();
    this.rangeSubject.next(range);
    this.searchSubject.next(range);
    return range;
  }

  private currentYearToDateRange(): TimesheetsDateRange {
    const today = new Date();
    return {
      fromDate: this.formatDate(new Date(today.getFullYear(), 0, 1)),
      toDate: this.formatDate(today),
    };
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private isValidRange(fromDate: string, toDate: string): boolean {
    return /^\d{4}-\d{2}-\d{2}$/.test(fromDate)
      && /^\d{4}-\d{2}-\d{2}$/.test(toDate)
      && fromDate <= toDate;
  }
}
